module.exports = __webpack_public_path__ + "static/img/Q_tiles.2cdf1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/Q_tiles.svg
// module id = xpqs
// module chunks = 1